"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenseCommentsMentionsEnum = void 0;
var ExpenseCommentsMentionsEnum;
(function (ExpenseCommentsMentionsEnum) {
    ExpenseCommentsMentionsEnum["COMMENTS"] = "my_comments";
    ExpenseCommentsMentionsEnum["MENTIONS"] = "my_mentions";
})(ExpenseCommentsMentionsEnum || (exports.ExpenseCommentsMentionsEnum = ExpenseCommentsMentionsEnum = {}));
